// extracted by mini-css-extract-plugin
export default {"photo":"Photo_photo__050gb","attach":"Photo_attach__AMh0v"};